/** Central test IDs registry - keeps tests stable. */
export const TID = {
  // landing
  landing: 'landing-page',
  goBailleur: 'landing-bailleur-btn',
  goLocataire: 'landing-locataire-btn',
  // login
  loginForm: 'login-form',
  loginIdentifier: 'login-identifier',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit-btn',
  // change password
  cpwCurrent: 'cpw-current',
  cpwNew: 'cpw-new',
  cpwSubmit: 'cpw-submit-btn',
  // admin
  adminSidebar: 'admin-sidebar',
  adminKpiBailleurs: 'admin-kpi-bailleurs',
  adminKpiLocataires: 'admin-kpi-locataires',
  adminKpiRevenue: 'admin-kpi-revenue',
  adminCreateBailleur: 'admin-create-bailleur-btn',
  adminBailleursTable: 'admin-bailleurs-table',
  adminBailleurRow: (id) => `admin-bailleur-row-${id}`,
  // create bailleur form
  cbNom: 'cb-nom', cbPrenom: 'cb-prenom', cbEmail: 'cb-email',
  cbTelephone: 'cb-telephone', cbOffer: 'cb-offer', cbSubmit: 'cb-submit-btn',
  cbCredentials: 'cb-credentials',
  // bailleur
  bailleurSidebar: 'bailleur-sidebar',
  bailleurKpiAttendu: 'bailleur-kpi-attendu',
  bailleurKpiRecu: 'bailleur-kpi-recu',
  bailleurKpiRetard: 'bailleur-kpi-retard',
  bailleurQuota: 'bailleur-quota',
  addLocataire: 'add-locataire-btn',
  // locataire form
  lcNom: 'lc-nom', lcPrenom: 'lc-prenom', lcTel: 'lc-tel',
  lcAdresse: 'lc-adresse', lcMontant: 'lc-montant', lcDevise: 'lc-devise',
  lcIdent: 'lc-identifier', lcPwd: 'lc-password', lcJour: 'lc-jour',
  lcSubmit: 'lc-submit-btn',
  // payment
  addPayment: 'add-payment-btn',
  payMontant: 'pay-montant', payMode: 'pay-mode', payRef: 'pay-ref', paySubmit: 'pay-submit-btn',
  // locataire portal
  locHistory: 'loc-history',
  locDownload: (id) => `loc-download-${id}`,
  // agent
  agentSidebar: 'agent-sidebar',
  agentCreateBailleur: 'agent-create-bailleur-btn',
  // shared
  logout: 'logout-btn',
  logoutConfirmPwd: 'logout-confirm-password',
  logoutConfirmBtn: 'logout-confirm-btn',
  // landing v2
  landingHeaderLogin: 'landing-header-login',
  landingLangSwitch: 'landing-lang-switch',
  // admin agents
  adminAgentsTable: 'admin-agents-table',
  adminCreateAgent: 'admin-create-agent-btn',
  caPrenom: 'ca-prenom', caNom: 'ca-nom', caEmail: 'ca-email',
  caTelephone: 'ca-telephone', caSubmit: 'ca-submit-btn',
  caCredentials: 'ca-credentials',
};
